const brand = {
  name: "NTAC",
  fullName: "Nexora Technology Advertising Company",
  short: "NTAC",
  legal: "NTAC",
  domain: "nexoratechadvertising.com",
  oneLiner: "Performance advertising that's measured by what moved — not what was reported.",
  pitch:
    "NTAC is a performance and programmatic advertising shop. We buy, build and measure paid media across search, social, display, CTV and retail — engineered around incremental contribution rather than last-click vanity.",
  contact: {
    email: "info@nexoratechadvertising.com",
    hours: "Mon — Fri · 09:00 — 18:00"
  },
  hq: {
    city: "Tirana",
    country: "Albania",
    address: {
      line1: "Rr. Murat Toptani, Ndërtesa",
      line2: "Tiranë, Albania"
    }
  },
  outcomes: [
    { big: "+312%", label: "ROAS lift on representative DTC engagement (Year-1)" },
    { big: "-41%", label: "CPA reduction after creative-velocity overhaul" },
    { big: "+8.4x", label: "Incremental sales lift confirmed via geo-holdout testing" },
    { big: "92%", label: "Of media spend operated against incrementality tests" }
  ],
  channels: [
    "Paid Search", "Paid Social", "Programmatic Display",
    "Connected TV", "Retail Media", "Native", "Affiliate", "App / ASA"
  ],
  pulse: [
    { d: "2026 · Q2", title: "Apple Search Ads campaign audit framework v2", tag: "OPS" },
    { d: "2026 · Q1", title: "Why MMM is back — and how to actually build one", tag: "MEASURE" },
    { d: "2025 · Q4", title: "Trendyol Ads vs Hepsiburada Ads — programmatic comparison", tag: "RETAIL" }
  ]
};

export default brand;
